interface Currency {
  displayName: string;
  numericCode: number;
  defaultFractionDigits: number;
  subUnit: number;
  symbolSpaced: boolean;
  symbolPosition: "after" | "before";
  symbol: string;
  isoCode: "RON";
};

const RON: Currency = Object.freeze({
  "displayName": "New Romanian Leu",
  "numericCode": 946,
  "defaultFractionDigits": 2,
  "subUnit": 100,
  "symbolSpaced": true,
  "symbolPosition": "after",
  "isoCode": "RON",
  "symbol": "lei"
});

export { RON };
